import { Reveal } from "./Reveal";

const EMAIL = "hello@getfetcher.in";

// Legal page shell with hero band + prose body
export const LegalPage = ({ eyebrow, title, updated, children }) => (
  <main className="bg-white pt-24">
    <section className="bg-gradient-to-br from-[#E86E28] via-[#D95A17] to-[#C24D0F] px-5 py-16 text-white sm:px-8">
      <div className="mx-auto max-w-3xl">
        <Reveal>
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-white/70">{eyebrow}</span>
          <h1 className="mt-3 text-4xl font-extrabold tracking-tight sm:text-5xl">{title}</h1>
          {updated && <p className="mt-4 text-sm font-semibold text-white/70">Last updated: {updated}</p>}
        </Reveal>
      </div>
    </section>
    <section className="px-5 py-16 sm:px-8">
      <div className="mx-auto max-w-3xl">{children}</div>
    </section>
  </main>
);

export const Section = ({ title, children }) => (
  <Reveal className="mt-10 first:mt-0">
    <h2 className="text-2xl font-extrabold tracking-tight text-slate-900">{title}</h2>
    <div className="mt-3 space-y-3 text-base font-medium leading-relaxed text-slate-600">{children}</div>
  </Reveal>
);

export const Mail = () => (
  <a href={`mailto:${EMAIL}`} className="font-bold text-[#D95A17] underline decoration-[#E86E28]/40 underline-offset-2 hover:decoration-[#E86E28]">
    {EMAIL}
  </a>
);
